import React, { FC } from 'react';
import Score, { ScoreProps } from '../../atoms/Score';
import { ScoreSize } from '../../atoms/Score/styled';
import * as SC from './styled';
export type RecipeNutritionFactsTableProps = {
  title: string;
  rows: {
    label: string;
    value: string;
  }[];
};
export type RecipeNutritionFactsProps = MinimalSeoBlock & {
  className?: string;
  score?: ScoreProps;
  title?: string;
  tables?: RecipeNutritionFactsTableProps[];
};
const RecipeNutritionFacts: FC<RecipeNutritionFactsProps> = ({
  className,
  htmlTag,
  score,
  title,
  htmlTitleTag,
  tables
}) => {
  return <SC.Container className={className} as={htmlTag}>
      {score && <Score value={score.value} size={ScoreSize.large} isV2={score.isV2} />}
      {title && <SC.Title as={htmlTitleTag}>{title}</SC.Title>}
      {tables && tables.length > 0 ? <>
          <SC.Tables>
            {tables?.map((table, tableIndex) => <SC.Table key={tableIndex} cellPadding={0} cellSpacing={0}>
                <thead>
                  <tr>
                    <th colSpan={2}>{table?.title}</th>
                  </tr>
                </thead>
                <tbody>
                  {table?.rows?.map((row, i) => <tr key={i}>
                      <td>{row.label}</td>
                      <td>{row.value}</td>
                    </tr>)}
                </tbody>
              </SC.Table>)}
          </SC.Tables>
        </> : undefined}
    </SC.Container>;
};
export default RecipeNutritionFacts;